// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_fg-0";
export var actionModalContentContainer = "_fg-1";